import { useState } from "react";

import { useNavigate } from "react-router-dom";


function ListingCard({ part, variant }) {
  const [hovered, setHovered] = useState(false);
    const navigate = useNavigate();


const today = new Date();

const startDelivery = new Date(today);
startDelivery.setDate(today.getDate() + 3);

const endDelivery = new Date(today);
endDelivery.setDate(today.getDate() + 4);

const deliveryStart = startDelivery.toLocaleDateString("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric"
});

const deliveryEnd = endDelivery.toLocaleDateString("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric"
});
const fallbackDelivery = `${deliveryStart} – ${deliveryEnd}`;



if (!part) return null;

const displayPrice =
  part.variants?.length
    ? Math.min(...part.variants.map(v => v.price))
    : part.price || 0;

const main = Math.floor(displayPrice);

const cents = (displayPrice % 1)
  .toFixed(2)
  .substring(2);

  return (
  <div
  style={{
    ...styles.card,

    ...(hovered && styles.cardHover),

    ...(variant === "diagram" && styles.diagramCard)
  }}

  onMouseEnter={() => setHovered(true)}

  onMouseLeave={() => setHovered(false)}

onClick={() => navigate(`/product/${part._id}`)}

>


      {/* IMAGE */}
    <div style={styles.imageWrap}>
 <img
src={part.images?.[0] ? `${part.images[0]}` : ""}
  style={styles.image}
  alt={part.title}
/>
</div>

<div style={styles.divider}></div>

{/* CONTENT */}
<div style={styles.content}>

        <div style={styles.sponsored}>
          Sponsored ⓘ
        </div>

        <div style={styles.title}>
       {part.title}
        </div>

        

       <div style={styles.priceRow}>
  <span style={styles.priceDollar}>$</span>
  <span style={styles.priceMain}>{main}</span>
  <span style={styles.priceCents}>{cents}</span>
</div>




      <div style={styles.delivery}>
  FREE delivery <b>{part.delivery || fallbackDelivery}</b>
</div>

<div style={styles.fastest}>
  ⚡ Or fastest delivery <b>{part.fastest || deliveryStart}</b>
</div>

      </div>

   
    {/* Add to Cart Button */}
{/* BUTTON */}
<div style={styles.buttonWrap}>
  <button
    style={styles.cartBtn}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.boxShadow =
        "0 18px 38px rgba(62,111,227,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)";
    }}
onClick={(e) => {
  e.stopPropagation();
  navigate(`/product/${part._id}`);
}}
  >
    Add to Cart
  </button>
</div>
      </div>


  );
}

const styles = {

card: {
  display: "flex",
  alignItems: "stretch",
  gap: 28,
  padding: 18,
  borderRadius: 22,

  background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

  border: "2px solid #ffffff",

  boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)",

  marginBottom: 20,

  transition:
  "transform .22s ease, box-shadow .22s ease",

willChange:
  "transform",


  cursor: "pointer",

},
imageWrap: {
  width: 50,
  height: 145,
  minWidth: 120,
  display: "flex",
 alignItems: "flex-end",
  justifyContent: "center"
},

diagramCard:{
  padding:18
},


cardHover:{
transform:"translateY(-4px)",
boxShadow:
"0 24px 50px rgba(0,0,0,0.10), 0 18px 45px rgba(37,99,235,0.14)"
},

divider: {
  width: 1,
  background: "linear-gradient(to bottom, transparent, #e3e3e8, transparent)",
  marginRight: 8
},

image: {
  width: "135%",
  objectFit: "contain",
  transform: "translateY(6px)"
},

content: {
  flex: 1,
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
},

sponsored: {
  fontSize: 13,
  color: "#6e6e73",
  marginBottom: 6
},

title: {
  fontSize: 17,
  lineHeight: "26px",
  lineHeight: "26px",
  color: "#1d1d1f",
  marginBottom: 10
},

priceRow: {
  display: "flex",
  alignItems: "baseline",
  marginBottom: 8
},

priceDollar: {
  fontSize: 16
},

priceMain: {
  fontSize: 30,
  fontWeight: 500
},

priceCents: {
  fontSize: 18
},

delivery: {
  fontSize: 15,
  marginBottom: 4
},

fastest: {
  fontSize: 14,
  color: "#565959"
},

buttonWrap: {
  width: 160,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center"
},

cartBtn: {
  padding: "10px 20px",   // smaller vertical padding
  height: 46,             // consistent height
  minWidth: 140,          // keeps button aligned across cards

  borderRadius: 30,       // less pill-shaped
  border: "none",

  background: "linear-gradient(180deg,#5a8efc,#1f57c8)",

  color: "white",
  fontWeight: 600,
  fontSize: 14,

  cursor: "pointer",
  transition: "all 0.18s ease",

  boxShadow:
    "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)"
},
};
export default ListingCard;